import {RepositoryFactory} from "@/repository/RepositoryFactory";

const BudgetToolRepository = RepositoryFactory.get('budget_tool')

export default {
  state:{
    budgetTool:[],
  },
  mutations: {
    SET_BUDGET_TOOLS: (state, data) => {
      state.budgetTool = data
    }
  },
  getters: {
    budgetTools: state => state.budgetTool,
  },
  actions:{
    async fetchAllBudgetTools({commit}, { filterQuery } ){
      const { data } = (await BudgetToolRepository.getBudgetToolList(filterQuery)).data
      const arr = Object.entries(data)
      const formatted_arr = []
      arr.forEach((x) => {
        formatted_arr.push(x[x.length - 1])
      })
      commit('SET_BUDGET_TOOLS', formatted_arr)
    }
  }
}
